// Generic Modal Component
export default class Modal {
    constructor(modalSelector) {
        this.modal = document.querySelector(modalSelector);
        if (!this.modal) return;

        this.backdrop = this.modal.querySelector(".modal__backdrop");
        this.closeButtons = this.modal.querySelectorAll(".modal__close, [data-modal-close]");

        this.init();
    }

    init() {
        // Close button handlers
        this.closeButtons.forEach(btn => {
            btn.addEventListener("click", () => this.close());
        });

        // Backdrop click to close
        if (this.backdrop) {
            this.backdrop.addEventListener("click", () => this.close());
        }

        // ESC key to close
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && this.isOpen()) {
                this.close();
            }
        });
    }

    open() {
        if (!this.modal) return;
        this.modal.classList.add("is-active");
        document.body.style.overflow = "hidden";
    }

    close() {
        if (!this.modal) return;
        this.modal.classList.remove("is-active");
        document.body.style.overflow = "";
    }

    isOpen() {
        return this.modal && this.modal.classList.contains("is-active");
    }

    // Static method to create and open a modal with custom content
    static create(options = {}) {
        const {
            title = "Modal",
            content = "",
            footer = "",
            size = "medium", // small, medium, large
            onClose = null
        } = options;

        // Create modal HTML
        const modalHTML = `
      <div class="modal modal--${size}" role="dialog" aria-labelledby="modal-title" aria-modal="true">
        <div class="modal__backdrop"></div>
        <div class="modal__container">
          <div class="modal__header">
            <h2 id="modal-title" class="modal__title">${title}</h2>
            <button type="button" class="modal__close" aria-label="Kapat">
              <i data-lucide="x"></i>
            </button>
          </div>
          <div class="modal__content">
            ${content}
          </div>
          ${footer ? `<div class="modal__footer">${footer}</div>` : ''}
        </div>
      </div>
    `;

        // Append to body
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = modalHTML;
        const modalElement = tempDiv.firstElementChild;
        document.body.appendChild(modalElement);

        // Initialize lucide icons if available
        if (window.lucide) {
            window.lucide.createIcons();
        }

        // Create modal instance
        const modal = new Modal('.modal');
        modal.open();

        // Add custom close handler
        if (onClose) {
            const originalClose = modal.close.bind(modal);
            modal.close = function () {
                originalClose();
                onClose();
                // Remove modal from DOM after animation
                setTimeout(() => modalElement.remove(), 300);
            };
        }

        return modal;
    }
}
